/**
 * Pre-compiled fr-FR messages for MoneyInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  amountInputLabel: `Montant`,
  currencySelectLabel: `Devise`,
  highPrecisionPrice: `Prix haute précision`,
};
